import React from 'react';
import { call, fork, put, takeEvery, takeLatest } from 'redux-saga/effects';
import { push } from 'react-router-redux';
import {
  ADD_TYPOLOGY_TO_MAPPING,
  addTriggerScenarioFail,
  addTriggerScenarioSuccess,
  addTypologyToMappingFail,
  addTypologyToMappingSuccess,
  APPROVE_REJECT_TICKETS,
  clearUploadTypologies,
  CLONE_SCENARIO,
  CONFIRM_TRM_TYPOLOGIES,
  confirmTypologiesFail,
  confirmTypologiesSuccess,
  CREATE_CHALLENGER,
  createChallengerFail,
  createChallengerSuccess,
  CREATE_SINGLE_SCENARIO,
  createSingleScenarioFail,
  createSingleScenarioSuccess,
  DELETE_SINGLE_SCENARIO,
  deleteSingleScenarioFail,
  deleteSingleScenarioSuccess,
  DISCARD_TRM_TYPOLOGIES,
  FETCH_ALL_SCENARIOS,
  FETCH_CHALLENGERS_SUMMARY,
  FETCH_CURRENT_CHALLENGER,
  FETCH_CURRENT_CHAMPION,
  FETCH_RUN_INSTANCE_HISTORY,
  FETCH_SINGLE_SCENARIO,
  FETCH_TICKETS,
  FETCH_TRM_TYPOLOGIES,
  FETCH_TRM_TYPOLOGIES_OF_SCENARIO,
  fetchAllScenarios,
  fetchAllScenariosFail,
  fetchAllScenariosSuccess,
  fetchChallengersSummary,
  fetchChallengersSummaryFail,
  fetchChallengersSummarySuccess,
  fetchCurrentChallengerFail,
  fetchCurrentChallengerSuccess,
  fetchCurrentChampionFail,
  fetchCurrentChampionSuccess,
  fetchRunInstanceHistoryFail,
  fetchRunInstanceHistorySuccess,
  fetchSingleScenarioFail,
  fetchSingleScenarioSuccess,
  fetchTicketsFail,
  fetchTicketsSuccess,
  fetchTypologiesFail,
  fetchTypologiesOfScenarioFail,
  fetchTypologiesOfScenarioSuccess,
  fetchTypologiesSuccess,
  REMOVE_TYPOLOGY_FROM_SCENARIO,
  REVERT_CURRENT_CHAMPION,
  revertCurrentChampionFail,
  revertCurrentChampionSuccess,
  TRIGGER_SCENARIO,
  REFRESH_SCENARIO_VALIDATION,
  showValidationErrors,
  UPDATE_SINGLE_SCENARIO,
  updateSingleScenarioFail,
  updateSingleScenarioSuccess,
  promoteChallengerSuccess,
  promoteChallengerFail,
  PROMOTE_CHALLENGER,
  FETCH_CHALLENGERS_SUMMARY_RESET,
  FETCH_CURRENT_CHAMPION_RESET,
  FETCH_SINGLE_SCENARIO_RESET,
  putTypologyOfScenariosListDataWorkerSuccess,
  putTypologyOfScenariosListDataWorkerFail,
  PUT_TRM_TYPOLOGIES_OF_SCENARIO,
  FETCH_BLACKLIST,
  fetchBlackListSuccess,
  fetchBlackListFail,

  // Configure scenario actions
  SAVE_TYPOLOGY_SEGMENTS,
  saveTypologySegmentsSuccess,
  saveTypologySegmentsFail,
  FETCH_SCENARIO_TYPOLOGIES,
  fetchScenarioTypologiesSuccess,
  fetchScenarioTypologiesFail
  // Configure scenario actions END
} from '../../redux/actions/trm/trmDashboard';
import * as api from '../../services/trm/trmServices';

import * as commpnApi from '../../services/common';
import { message, notification } from 'antd';

const networkLayerObject = new api.NetworkLayer();

const commonLayerObject = new commpnApi.NetworkLayer();
// configure scenario sagas

function* fetchScenarioTypologiesDataWorker(payload) {
  try {
    const response = yield call(
      networkLayerObject.fetchScenarioTypologiesAPI,
      payload
    );
    yield put(fetchScenarioTypologiesSuccess(response));
  } catch (error) {
    yield put(fetchScenarioTypologiesFail({ error: '' }));
  }
}

export function* watchFetchScenarioTypologies() {
  yield takeEvery(FETCH_SCENARIO_TYPOLOGIES, function* ({ payload }) {
    yield fork(fetchScenarioTypologiesDataWorker, payload);
  });
}

function* saveTypologySegmentsDataWorker(payload) {
  try {
    const response = yield call(
      networkLayerObject.saveTypologySegmentAPI,
      payload
    );
    notification.open({
      message: (
        <p>
          <i style={{ color: '#2ecc71' }} className="fa fa-check"></i>
          &nbsp;&nbsp; {'Success!!'}
        </p>
      ),
      description: 'Typology updated!!'
    });
    yield put(saveTypologySegmentsSuccess(response));
    const resp = yield call(
      networkLayerObject.fetchScenarioTypologiesAPI,
      payload
    );
    yield put(fetchScenarioTypologiesSuccess(resp));
  } catch (error) {
    notification.open({
      message: (
        <p>
          <i style={{ color: '#e74c3c' }} className="fa fa-close"></i>
          &nbsp;&nbsp;Something went wrong
        </p>
      ),
      description: ''
    });
    yield put(saveTypologySegmentsFail({ error: '' }));
  }
}

export function* watchSaveTypologySegments() {
  yield takeEvery(SAVE_TYPOLOGY_SEGMENTS, function* ({ payload }) {
    yield fork(saveTypologySegmentsDataWorker, payload);
  });
}

// configure scenario END

function* getTypologyListDataWorker(payload) {
  try {
    const response = yield call(networkLayerObject.trmTypologiesAPI, payload);
    yield put(fetchTypologiesSuccess(response));
  } catch (error) {
    yield put(fetchTypologiesFail({ error: '' }));
  }
}

export function* watchGetTypologyListData() {
  yield takeEvery(FETCH_TRM_TYPOLOGIES, function* ({ payload }) {
    yield fork(getTypologyListDataWorker, payload);
  });
}

function* getBlackListDataWorker(payload) {
  try {
    const response = yield call(
      commonLayerObject.amlsCommonBlackListAPI,
      payload
    );
    yield put(fetchBlackListSuccess(response));
  } catch (error) {
    yield put(fetchBlackListFail({ error: '' }));
  }
}

export function* watchGetBlackListData() {
  yield takeEvery(FETCH_BLACKLIST, function* ({ payload }) {
    yield fork(getBlackListDataWorker, payload);
  });
}

function* getTypologyOfScenariosListDataWorker(payload) {
  try {
    const response = yield call(
      networkLayerObject.trmScenarioTypologiesListAPI,
      payload
    );
    yield put(fetchTypologiesOfScenarioSuccess(response));
  } catch (error) {
    yield put(fetchTypologiesOfScenarioFail({ error: '' }));
  }
}

export function* watchGetTypologyListOfScenariosData() {
  yield takeEvery(FETCH_TRM_TYPOLOGIES_OF_SCENARIO, function* ({ payload }) {
    yield fork(getTypologyOfScenariosListDataWorker, payload);
  });
}

// FIN-7250: putDataToServer resolves with the axios error on a non-2xx, so
// the response body sits on `.response.data` (a 2xx keeps it on `.data`).
const saveErrorBody = (response) => response?.data ?? response?.response?.data;

// FIN-11810: exported so the B.1 RED spec can step through the
// generator. Re-validates the scenario after every 202 so the
// Typologies-tab badges (FIN-11812) flip cross→tick the moment the
// user fixes an offending variant.
export function* putTypologyOfScenariosListDataWorker(payload) {
  try {
    const response = yield call(
      networkLayerObject.putTypologyFromScenarioAPI,
      payload
    );
    if (response.status === 202) {
      yield put(putTypologyOfScenariosListDataWorkerSuccess(response));
      const response1 = yield call(
        networkLayerObject.trmScenarioTypologiesListAPI,
        {
          scenarioID: payload.scenarioID
        }
      );
      yield put(fetchTypologiesOfScenarioSuccess(response1));

      message.success({
        key: 'success',
        content: 'Configuration saved successfully.'
      });

      // FIN-11810: refresh validation status — flips badges on the
      // Typologies tab without re-opening the modal.
      try {
        const validateResponse = yield call(
          networkLayerObject.validateScenarioAPI,
          payload.scenarioID
        );
        const warnings = (validateResponse && validateResponse.warnings) || [];
        yield put(
          showValidationErrors({
            scenarioID: payload.scenarioID,
            errors: (validateResponse && validateResponse.errors) || [],
            warnings,
            visible: false
          })
        );
        // FIN-13484: advisory only — the save succeeded. Point at the badges, where each
        // warning is readable per variant.
        if (warnings.length > 0) {
          message.warning({
            key: 'validation-warnings',
            duration: 6,
            content: `Saved with ${warnings.length} rule warning${
              warnings.length === 1 ? '' : 's'
            } — see the amber badges on the Typologies tab.`
          });
        }
      } catch (refreshErr) {
        // Validation refresh is best-effort — a transient failure must
        // not roll back the user's successful save. Stale badges are
        // acceptable; the next save or Launch click corrects them.
      }
    } else if (response.status === 500) {
      message.error(
        `The rule configuration is invalid, please complete the rules before saving`
      );
      yield put(putTypologyOfScenariosListDataWorkerFail({ error: '' }));
    } else if (
      (response.status ?? response.response?.status) === 422 &&
      saveErrorBody(response)?.errors?.length > 0
    ) {
      // FIN-7250: a rejected save carries one structured entry per failing
      // variant. Show them in the same modal as the Launch gate; the drawer
      // stays open (it closes only on PUT_..._SUCCESS) so no work is lost.
      yield put(
        showValidationErrors({
          scenarioID: payload.scenarioID,
          errors: saveErrorBody(response).errors,
          warnings: [],
          visible: true
        })
      );
      yield put(putTypologyOfScenariosListDataWorkerFail({ error: '' }));
    } else {
      message.error({
        content:
          saveErrorBody(response)?.message ??
          `Error in saving typology. Please try again later.`,
        duration: 5,
        style: {
          width: '60%',
          marginLeft: '20%'
        }
      });
      yield put(putTypologyOfScenariosListDataWorkerFail({ error: '' }));
    }
  } catch (error) {
    // FIN-7250: a failure is an error toast, not a (green) success one.
    message.error({
      key: 'error',
      content: error?.message ?? 'Error in saving typology.'
    });
    yield put(putTypologyOfScenariosListDataWorkerFail({ error }));
  }
}

export function* watchPutTypologyOfScenariosListDataWorker() {
  yield takeEvery(PUT_TRM_TYPOLOGIES_OF_SCENARIO, function* ({ payload }) {
    yield fork(putTypologyOfScenariosListDataWorker, payload);
  });
}

function* fetchRunInstanceHistoryDataWorker(payload) {
  try {
    const response = yield call(
      networkLayerObject.getRunInstanceHistoryAPI,
      payload
    );
    yield put(fetchRunInstanceHistorySuccess(response));
  } catch (error) {
    yield put(fetchRunInstanceHistoryFail({ error: '' }));
  }
}

export function* watchRunInstanceHistoryDataWorker() {
  yield takeEvery(FETCH_RUN_INSTANCE_HISTORY, function* ({ payload }) {
    yield fork(fetchRunInstanceHistoryDataWorker, payload);
  });
}

function* uploadConfirmDataWorker(payload) {
  try {
    const response = yield call(
      networkLayerObject.trmConfirmUploadAPI,
      payload
    );
    yield put(confirmTypologiesSuccess(response));
  } catch (error) {
    yield put(confirmTypologiesFail({ error: error.message }));
  }
}

export function* watchUploadConfirmData() {
  yield takeEvery(CONFIRM_TRM_TYPOLOGIES, function* ({ payload }) {
    yield fork(uploadConfirmDataWorker, payload);
  });
}

function* discardUploadedTypologiesDataWorker(payload) {
  try {
    const response = yield call(
      networkLayerObject.trmDiscardUploadAPI,
      payload
    );
    yield put(clearUploadTypologies());
  } catch (error) {
    yield put(clearUploadTypologies());
  }
}

export function* watchUploadDiscardTypologiesData() {
  yield takeEvery(DISCARD_TRM_TYPOLOGIES, function* ({ payload }) {
    yield fork(discardUploadedTypologiesDataWorker, payload);
  });
}

/**FETCH ALL SCENARIOS**/
function* getAllScenariosAPIDataWorker({ payload }) {
  try {
    const response = yield call(networkLayerObject.getAllScenariosAPI, payload);
    if (response && Array.isArray(response.scenarios)) {
      yield put(fetchAllScenariosSuccess(response));
    } else {
      yield put(
        fetchAllScenariosFail({
          error: response?.message || 'Failed to load scenarios'
        })
      );
    }
  } catch (error) {
    yield put(fetchAllScenariosFail({ error: error?.message || '' }));
  }
}

export function* watchGetAllScenariosAPIData() {
  yield takeLatest(FETCH_ALL_SCENARIOS, getAllScenariosAPIDataWorker);
}

/**FETCH CHALLENGERS SUMMARY*/
function* getChallengersSummaryAPIDataWorker(payload) {
  try {
    const response = yield call(
      networkLayerObject.fetchChallengersSummariesAPI,
      payload
    );
    yield put(fetchChallengersSummarySuccess(response));
  } catch (error) {
    yield put(fetchChallengersSummaryFail({ error: '' }));
  }
}

export function* watchGetChallengersSummaryAPIData() {
  yield takeEvery(FETCH_CHALLENGERS_SUMMARY, function* ({ payload }) {
    yield fork(getChallengersSummaryAPIDataWorker, payload);
  });
}

function* getChallengersSummaryResetWorker(payload) {
  try {
    yield put(fetchChallengersSummarySuccess({}));
    return;
  } catch (error) {
    yield put(fetchChallengersSummaryFail({ error: '' }));
  }
}

export function* watchGetChallengersSummaryReset() {
  yield takeEvery(FETCH_CHALLENGERS_SUMMARY_RESET, function* ({ payload }) {
    yield fork(getChallengersSummaryResetWorker, payload);
  });
}

/**REVERT CURRENT CHAMPION*/
function* revertCurrentChampionAPIDataWorker({
  currentChampionId,
  sourceId,
  scheduled
}) {
  try {
    yield call(networkLayerObject.revertCurrentChampionAPI, {
      currentChampionId,
      scheduled
    });
    yield put(revertCurrentChampionSuccess());
    message.info('Current champion was reverted.');
    yield put(fetchChallengersSummary({ sourceId, scheduled }));
  } catch (error) {
    yield put(revertCurrentChampionFail());
    message.error(error.message || 'Failed to revert the current champion.');
  }
}

export function* watchRevertCurrentChampionAPIData() {
  yield takeEvery(REVERT_CURRENT_CHAMPION, function* ({ payload }) {
    yield fork(revertCurrentChampionAPIDataWorker, payload);
  });
}

/**PROMOTE CHALLENGER*/
function* promoteChallengerAPIDataWorker({
  challengerId,
  sourceId,
  scheduled
}) {
  try {
    yield call(networkLayerObject.promoteChallengerAPI, { challengerId });
    yield put(promoteChallengerSuccess());
    message.info(
      'Promote Challenger to Champion request is submitted for approval.'
    );
    yield put(fetchChallengersSummary({ sourceId, scheduled }));
  } catch (error) {
    yield put(promoteChallengerFail());
    message.error(error.message || 'Failed to promote challenger to champion.');
  }
}

export function* watchPromoteChallengerAPIData() {
  yield takeEvery(PROMOTE_CHALLENGER, function* ({ payload }) {
    yield fork(promoteChallengerAPIDataWorker, payload);
  });
}

/**FETCH SINGLE SCENARIO**/
function* getScenarioDetailAPIDataWorker(payload) {
  try {
    const response = yield call(
      networkLayerObject.getSingleScenarioDetailAPI,
      payload
    );
    yield put(fetchSingleScenarioSuccess(response));
  } catch (error) {
    yield put(fetchSingleScenarioFail({ error: '' }));
  }
}

export function* watchGetScenarioDetailAPIData() {
  yield takeEvery(FETCH_SINGLE_SCENARIO, function* ({ payload }) {
    yield fork(getScenarioDetailAPIDataWorker, payload);
  });
}

function* getScenarioDetailResetWorker(payload) {
  try {
    yield put(fetchSingleScenarioSuccess({}));
  } catch (error) {
    yield put(fetchSingleScenarioFail({ error: '' }));
  }
}

export function* watchGetScenarioDetailReset() {
  yield takeEvery(FETCH_SINGLE_SCENARIO_RESET, function* ({ payload }) {
    yield fork(getScenarioDetailResetWorker, payload);
  });
}

/**CREATE SCENARIO**/
function* createScenariosAPIDataWorker(payload) {
  try {
    const response = yield call(networkLayerObject.createScenarioAPI, payload);
    yield put(createSingleScenarioSuccess(response));
    // Invalidate the run-instance listing so SummaryTab on /app/trm/run-instance
    // doesn't show stale data after the user navigates there. Without this the
    // listing's useEffect with [] deps may fire its GET before this POST has
    // persisted (the dispatch is sync, the saga is async), and the user only
    // sees the new run instance after a hard refresh.
    // FIN-12904 sibling fix: carry the caller's sourceId so the invalidation doesn't
    // clobber a source-scoped listing with an unfiltered one.
    yield put(
      fetchAllScenarios({ page: 1, pageSize: 20, sourceId: payload?.sourceId })
    );
  } catch (error) {
    yield put(createSingleScenarioFail({ error: '' }));
  }
}

export function* watchCreateScenariosAPIData() {
  yield takeEvery(CREATE_SINGLE_SCENARIO, function* ({ payload }) {
    yield fork(createScenariosAPIDataWorker, payload);
  });
}

/**DELETE SCENARIO**/
function* deleteScenariosAPIDataWorker(payload) {
  try {
    const response = yield call(networkLayerObject.deleteScenarioAPI, payload);
    yield put(deleteSingleScenarioSuccess(response));
  } catch (error) {
    yield put(deleteSingleScenarioFail({ error: '' }));
  }
}

export function* watchDeleteScenariosAPIDataWorker() {
  yield takeEvery(DELETE_SINGLE_SCENARIO, function* ({ payload }) {
    yield fork(deleteScenariosAPIDataWorker, payload);
  });
}

/**UPDATE SCENARIO**/
function* updateScenariosAPIDataWorker(payload) {
  try {
    const response = yield call(networkLayerObject.updateScenarioAPI, payload);
    yield put(updateSingleScenarioSuccess(response));
  } catch (error) {
    yield put(updateSingleScenarioFail({ error: '' }));
  }
}

export function* watchUpdateScenariosAPIDataWorker() {
  yield takeEvery(UPDATE_SINGLE_SCENARIO, function* ({ payload }) {
    yield fork(updateScenariosAPIDataWorker, payload);
  });
}

/**ADD TYPOLOGY TO SCENARIO**/
function* addTypologyToScenariosAPIDataWorker(payload) {
  try {
    const response = yield call(
      networkLayerObject.addMappingToScenarioAPI,
      payload
    );
    yield put(addTypologyToMappingSuccess(response));
    // Same invalidation as createScenariosAPIDataWorker — the typology mapping
    // changes the listing's row contents (rule-count column, etc.) and is the
    // last step in the "create run instance from typology" flow, so refetching
    // here covers both create + attach in a single round-trip.
    // FIN-12904 sibling fix: preserve the caller's source scope (see clone worker).
    yield put(
      fetchAllScenarios({ page: 1, pageSize: 20, sourceId: payload?.sourceId })
    );
  } catch (error) {
    yield put(addTypologyToMappingFail({ error: '' }));
  }
}

export function* watchAddTypologyToScenariosAPIDataWorker() {
  yield takeEvery(ADD_TYPOLOGY_TO_MAPPING, function* ({ payload }) {
    yield fork(addTypologyToScenariosAPIDataWorker, payload);
  });
}

/**Trigger SCENARIO — FIN-11800: validate-before-launch gate.**/
//
// Sequence:
//   1. GET /scenarios/{id}/validate (new in Phase 3, FIN-11796).
//   2. If errors[] is non-empty → put(showValidationErrors(errors)) and
//      short-circuit. The ScenarioValidationErrorModal (FIN-11802) listens
//      for SHOW_VALIDATION_ERRORS and renders the table; execute never
//      fires. Treated as a fail of the launch (addTriggerScenarioFail) so
//      any progress spinners in the UI clear.
//   3. Else → existing POST /scenarios/{id}/execute path.
//
// Exported (was previously file-private) so the FIN-11799 RED spec can
// step through the generator and assert the first yielded effect is the
// validate call.
export function* triggerScenarioAPIDataWorker(payload) {
  try {
    const validateResponse = yield call(
      networkLayerObject.validateScenarioAPI,
      payload.scenarioID
    );
    // FIN-11922 (fail-closed): a successful /validate returns { errors: [...] }.
    // getDataFromServer swallows HTTP errors into an Error object, so anything
    // without an `errors` ARRAY means validation could NOT be performed — do
    // NOT fire /execute with unknown validation status. Surface and stop.
    if (!validateResponse || !Array.isArray(validateResponse.errors)) {
      yield put(addTriggerScenarioFail({ error: 'validation-unavailable' }));
      message.error('Could not validate the scenario rules. Please try again.');
      return;
    }
    const errors = validateResponse.errors;
    const warnings = validateResponse.warnings || [];
    if (errors.length > 0) {
      yield put(
        showValidationErrors({ scenarioID: payload.scenarioID, errors, warnings })
      );
      yield put(addTriggerScenarioFail({ error: 'validation' }));
      return;
    }
    // FIN-13484: warnings never block launch; refresh the badges silently and proceed.
    if (warnings.length > 0) {
      yield put(
        showValidationErrors({
          scenarioID: payload.scenarioID,
          errors,
          warnings,
          visible: false
        })
      );
    }

    const response = yield call(
      networkLayerObject.triggerScenariosAPI,
      payload
    );

    yield put(addTriggerScenarioSuccess(response));
  } catch (error) {
    yield put(addTriggerScenarioFail({ error }));
  }
}

export function* watchTriggerScenariosAPIDataWorker() {
  yield takeEvery(TRIGGER_SCENARIO, function* ({ payload }) {
    yield fork(triggerScenarioAPIDataWorker, payload);
  });
}

/** FIN-11922 — proactive validation-badge refresh on Configure-page load. **/
//
// Calls GET /scenarios/{id}/validate and dispatches showValidationErrors with
// visible:false so the Typologies-tab badges (FIN-11812) reflect the current
// validation state immediately, instead of only after a save (FIN-11810) or a
// Launch/Generate attempt. Best-effort: a failed/erroring /validate leaves the
// existing badges untouched and never blocks the page.
export function* refreshScenarioValidationWorker(payload) {
  try {
    const validateResponse = yield call(
      networkLayerObject.validateScenarioAPI,
      payload.scenarioID
    );
    if (validateResponse && Array.isArray(validateResponse.errors)) {
      yield put(
        showValidationErrors({
          scenarioID: payload.scenarioID,
          errors: validateResponse.errors,
          warnings: validateResponse.warnings || [],
          visible: false
        })
      );
    }
  } catch (error) {
    // best-effort badge refresh — ignore failures
  }
}

export function* watchRefreshScenarioValidation() {
  yield takeLatest(REFRESH_SCENARIO_VALIDATION, function* ({ payload }) {
    yield fork(refreshScenarioValidationWorker, payload);
  });
}

/** Remove Typology from Scenario**/
function* removeTypologyFromScenarioDataWorker(payload) {
  try {
    const response = yield call(
      networkLayerObject.removeTypologyFromScenarioAPI,
      payload
    );
    yield put(fetchTypologiesOfScenarioSuccess(response));
  } catch (error) {
    yield put(fetchTypologiesOfScenarioFail({ error: '' }));
  }
}

export function* watchRemoveTypologyFromScenarioDataWorker() {
  yield takeEvery(REMOVE_TYPOLOGY_FROM_SCENARIO, function* ({ payload }) {
    yield fork(removeTypologyFromScenarioDataWorker, payload);
  });
}

/** CLONE_SCENARIO **/
export function* cloneScenarioDataWorker(payload) {
  try {
    // FIN-12904: the service returns the bare POST result now; refetch the listing
    // EXPLICITLY with the caller's source scope so the clone shows up without
    // clobbering the dashboard with an unfiltered default-limit list (FIN-11930).
    yield call(networkLayerObject.cloneScenarioAPI, payload);
    // FIN-12991: a caller that owns its pager reloads itself (keeping its page size
    // and filter, and moving the pager to page 1 with the data). Only reached once
    // the clone succeeded, so a rejected name leaves the listing untouched.
    if (payload?.onSuccess) {
      yield call(payload.onSuccess);
    } else {
      yield put(
        fetchAllScenarios({ page: 1, pageSize: 20, sourceId: payload?.sourceId })
      );
    }
  } catch (error) {
    yield put(fetchAllScenariosFail({ error }));
  }
}

export function* watchCloneScenarioDataWorker() {
  yield takeEvery(CLONE_SCENARIO, function* ({ payload }) {
    yield fork(cloneScenarioDataWorker, payload);
  });
}

/** FETCH TICKETS **/
function* fetchTicketsDataWorker(payload) {
  try {
    const { requests = [], totalCount = 0 } = yield call(
      networkLayerObject.fetchTicketsListAPI,
      payload
    );
    yield put(fetchTicketsSuccess({ requests, totalCount }));
  } catch (error) {
    yield put(fetchTicketsFail({ error: '' }));
  }
}

export function* watchFetchTicketsDataWorker() {
  yield takeEvery(FETCH_TICKETS, function* ({ payload }) {
    yield fork(fetchTicketsDataWorker, payload);
  });
}

/** Approve Reject Tickets **/
function* approveRejectTicketsDataWorker(payload) {
  try {
    const response = yield call(
      networkLayerObject.approveRejectTicketsAPI,
      payload
    );
    yield put(fetchTicketsSuccess(response));
  } catch (error) {
    yield put(fetchTicketsFail({ error: '' }));
  }
}

export function* watchApproveRejectTicketsDataWorker() {
  yield takeEvery(APPROVE_REJECT_TICKETS, function* ({ payload }) {
    yield fork(approveRejectTicketsDataWorker, payload);
  });
}

/** fetch currentChampion  **/
function* fetchCurrentChampionDataWorker(payload) {
  try {
    const response = yield call(
      networkLayerObject.fetchCurrentChampionAPI,
      payload
    );
    yield put(fetchCurrentChampionSuccess(response));
  } catch (error) {
    yield put(fetchCurrentChampionFail({ error: '' }));
  }
}

export function* watchFetchCurrentChampionDataWorker() {
  yield takeEvery(FETCH_CURRENT_CHAMPION, function* ({ payload }) {
    yield fork(fetchCurrentChampionDataWorker, payload);
  });
}

function* fetchCurrentChampionResetDataWorker(payload) {
  try {
    yield put(fetchCurrentChampionSuccess({}));
  } catch (error) {
    yield put(fetchCurrentChampionFail({ error: '' }));
  }
}

export function* watchFetchCurrentChampionResetDataWorker() {
  yield takeEvery(FETCH_CURRENT_CHAMPION_RESET, function* ({ payload }) {
    yield fork(fetchCurrentChampionResetDataWorker, payload);
  });
}

/** fetch currentChallenger  **/
function* fetchCurrentChallengerWorker(payload) {
  try {
    const response = yield call(
      networkLayerObject.fetchCurrentChallengerAPI,
      payload
    );
    yield put(fetchCurrentChallengerSuccess(response));
  } catch (error) {
    yield put(fetchCurrentChallengerFail({ error: '' }));
  }
}

export function* watchFetchCurrentChallengerWorker() {
  yield takeEvery(FETCH_CURRENT_CHALLENGER, function* ({ payload }) {
    yield fork(fetchCurrentChallengerWorker, payload);
  });
}

/** create Challenger  **/
function* createChallengerDataWorker(payload) {
  try {
    yield call(networkLayerObject.createChallengerAPI, payload);
    yield put(createChallengerSuccess());
    message.info('Challenger create request is submitted for approval.');
    yield put(push(`/app/trm/run-instance`));
  } catch (error) {
    yield put(createChallengerFail());
    message.error(error.message || 'Failed to create challenger.');
  }
}

export function* watchCreateChallengerDataWorker() {
  yield takeEvery(CREATE_CHALLENGER, function* ({ payload }) {
    yield fork(createChallengerDataWorker, payload);
  });
}
